import { observer } from 'mobx-react-lite'
import { Outlet, useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { SpinnerLoader } from 'shared/ui'
import { checkAccessPage, EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

export const InboxAddNumberAccessLayout = observer(() => {
  const { id } = useParams()
  const entities = useEntitiesContext()
  const [loading, setLoading] = useState<boolean>(true)
  const { usersStore, userPermissionsStore, featureFlagsStore } = entities

  useEffect(() => {
    Promise.all([
      usersStore.initPromise,
      userPermissionsStore.initPromise,
      featureFlagsStore.fetchFeatureFlags(),
    ]).then(() => {
      const isBillingSettingsAccess = userPermissionsStore.canManageBilling
      const isAdminRole = usersStore.user?.isAdminRole
      const isManageOrganizationInboxes = checkAccessPage(EnumAccessPageKeys.inbox_page, entities)

      if (isManageOrganizationInboxes) {
        return setLoading(false)
      }
      if (isAdminRole && isBillingSettingsAccess) {
        return setLoading(false)
      }

      uiStore.changeRouteViaVue({
        path: InboxesPath.inboxNumbers(Number(id)),
      })
    })
  }, [])

  if (loading) return <SpinnerLoader ariaLabel={'InboxAddNumberAccessLayout'} />

  return (
    <>
      <Outlet />
    </>
  )
})
